module.exports = __webpack_public_path__ + "img/logout.2212ff39.svg";